import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import {
  Response,
  QueryRequest,
  PersonalCertificate,
  CertificateIdsRequest,
  CertificateEditRequest,
  PersonalCertificateIds,
  CertificateDeleteRequest,
  CertificateDeleteReponse,
  CertificateResetPinReponse,
  CertificateResetPinRequest,
  CertificateChangePinRequest,
  CertificateChangePinResponse,
  CertificateFpDownloadRequest,
  PagedTableResponse,
  PagedTableRequest,
  ContentType,
} from '@models/index.model';
import { Observable } from 'rxjs';
import { UtilsService } from '@utils/utils.service';
import { RemovePinReponse, RemovePinRequest } from '@models/certificates/certificates.model';

@Injectable({
  providedIn: 'root',
})
export class CertificatesPrivateService {
  private UrlAPI = environment.apiUrl;

  constructor(private http: HttpClient, private _utils: UtilsService) {}

  public getPersonalCertificates(
    certificatesRequest: PagedTableRequest
  ): Observable<Response<PagedTableResponse<PersonalCertificate>>> {
    const query = this.UrlAPI + QueryRequest.listPersonalCertificates;
    return this.http.post<Response<PagedTableResponse<PersonalCertificate>>>(
      query,
      this._utils.stringifyData(certificatesRequest)
    );
  }

  public getPersonalCertificateIds(
    certificatesRequest: CertificateIdsRequest
  ): Observable<Response<PersonalCertificateIds>> {
    const query = this.UrlAPI + QueryRequest.listPersonalCertificateIds;
    return this.http.post<Response<PersonalCertificateIds>>(query, this._utils.stringifyData(certificatesRequest));
  }

  public uploadPersonalCertificate(
    certificateEditRequest: CertificateEditRequest,
    file: File
  ): Observable<Response<any>> {
    const query = this.UrlAPI + QueryRequest.personalCertificate;
    const httpHeaders = new HttpHeaders({ 'Content-Type': ContentType.formDataType });
    const options = { headers: httpHeaders };
    const formdata: FormData = new FormData();
    formdata.append('file', file, file.name);
    formdata.append('jsonUploadData', this._utils.stringifyData(certificateEditRequest));
    return this.http.post<Response<any>>(query, formdata, options);
  }

  public deletePersonalCertificate(
    certificateDeleteRequest: CertificateDeleteRequest
  ): Observable<Response<CertificateDeleteReponse>> {
    const query = this.UrlAPI + QueryRequest.personalCertificate;
    const options = { body: this._utils.stringifyData(certificateDeleteRequest) };
    return this.http.delete<Response<CertificateDeleteReponse>>(query, options);
  }

  public removePersonalCertificatePIN(
    removePINRequest: RemovePinRequest
  ): Observable<Response<RemovePinReponse>> {
    const query = this.UrlAPI + QueryRequest.personalCertificateRemovePin;
    return this.http.put<Response<RemovePinReponse>>(query, this._utils.stringifyData(removePINRequest));
  }

  public resetPinPersonalCertificate(
    certificateResetPinRequest: CertificateResetPinRequest
  ): Observable<Response<CertificateResetPinReponse>> {
    const query = this.UrlAPI + QueryRequest.personalCertificateResetPin;
    return this.http.put<Response<CertificateResetPinReponse>>(
      query,
      this._utils.stringifyData(certificateResetPinRequest)
    );
  }

  public changePinPersonalCertificate(
    certificateChangePinRequest: CertificateChangePinRequest
  ): Observable<Response<CertificateChangePinResponse>> {
    const query = this.UrlAPI + QueryRequest.personalCertificateChangePin;
    return this.http.put<Response<CertificateChangePinResponse>>(
      query,
      this._utils.stringifyData(certificateChangePinRequest)
    );
  }

  public downloadFpCertificate(certificateFpDownloadRequest: CertificateFpDownloadRequest) {
    const query = this.UrlAPI + QueryRequest.fpCertificateDownload;
    const httpHeaders = new HttpHeaders({
      timeout: environment.timeoutFP.toString(),
    });
    return this.http.put(query, certificateFpDownloadRequest, {
      observe: 'response',
      responseType: 'arraybuffer',
      headers: httpHeaders,
    });
  }
}
